<template>
  <audio ref="bgMusic" loop>
    <source src="@/assets/lover.mp3" type="audio/mpeg" />
  </audio>
  <router-view />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'App',
  setup() {
    const bgMusic = ref<HTMLAudioElement | null>(null);

    onMounted(() => {
      // Add listeners for any user interaction to start playback
      const playOnInteraction = () => {
        if (bgMusic.value) {
          bgMusic.value.play().catch((error) => {
            console.log('Playback failed:', error);
          });
          // Remove all listeners after first successful interaction
          document.removeEventListener('click', playOnInteraction);
          document.removeEventListener('touchstart', playOnInteraction);
          document.removeEventListener('keydown', playOnInteraction);
        }
      };

      // Listen for various user interactions
      document.addEventListener('click', playOnInteraction);
      document.addEventListener('touchstart', playOnInteraction);
      document.addEventListener('keydown', playOnInteraction);
    });

    return {
      bgMusic,
    };
  },
});
</script>

<style lang="scss">
@import '@/scss/main.scss';
</style>
